import { render, staticRenderFns } from "./IndexGinee.vue?vue&type=template&id=6a971e88&"
import script from "./IndexGinee.vue?vue&type=script&lang=js&"
export * from "./IndexGinee.vue?vue&type=script&lang=js&"
import style0 from "./IndexGinee.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports